<template>
  <div class="user__info">
    <div class="user__ava">
      <img v-if="user.avatar" :src="user.avatar" alt="" />
      <SvgIcon v-else size="80%" name="user-light" />
    </div>
    <div class="user__name ellipsis">
      <span class="ellipsis">{{ user.nickname }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["user"])
  }
};
</script>

<style lang="scss">
.user {
  &__info,
  &__ava,
  &__name {
    display: inline-flex;
    align-items: center;
  }

  &__info {
    justify-content: flex-start;
    max-width: 220px;

    @include breakpoint("md-only") {
      max-width: 135px;
    }
  }

  &__ava {
    margin-right: 12px;
    height: 50px;
    width: 50px;
    min-width: 50px;
    padding: 1px;
    position: relative;
    overflow: hidden;

    flex: 0 0 0;

    background: #1480b2;
    color: rgba(#1480b2, 0.8);

    display: flex;
    align-items: center;
    justify-content: center;

    img,
    svg {
      height: 100%;
      display: block;
      position: relative;
      z-index: 1;
    }

    svg {
      margin: 0;
      width: 80%;
    }

    .btn__content {
      justify-content: center;
    }

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
    }

    &:before {
      left: -25px;
      right: -25px;
      bottom: -25px;
      top: -25px;
      box-shadow: 0px -100px 25px -50px #e72f31 inset;
      transform: rotate(45deg);
      transform-origin: center;
      animation: rotate 20s linear infinite;
      z-index: 0;
    }

    &:after {
      left: 1px;
      right: 1px;
      bottom: 1px;
      top: 1px;
      background: #0d5577;
    }
  }
}

.user__info {
  .menubar & {
    flex: 1 1 100% !important;
  }
}
</style>
